import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DomainService } from '../../../services/domain.service';
import { AuthService } from '../../../services/auth.service';
import { NotificationService } from '../../../services/notification.service';
import { EnvironmentService } from '../../../services/environment.service';

@Component({
    selector: 'itpx-learning-tile',
    templateUrl: './component.html',
    styleUrls: ['./component.css']
})
export class LearningTileComponent implements OnInit {

    @Input() deliverableStatus: any;
    @Input() status: string = 'ready';
    @Input() target: Array<any> = [];
    @Input() logo: string;
    @Input() name: string;
    @Input() errorMessage: string;
    @Input() disabled: boolean = false;
    @Input() availableUntil: any;
    @Input() deliverable: any;
    @Input() isElearning: boolean = false;

    private domain: any;
    private images: string;

    constructor(
        private router: Router,
        private domainService: DomainService,
        private authService: AuthService,
        private notificationService: NotificationService,
        private environmentService: EnvironmentService
    ) {
    }

    ngOnInit() {
        this.domain = this.domainService.getDomain();
        this.images = this.environmentService.config['server'].images;

        console.log(this.deliverable)
    }

}



// WEBPACK FOOTER //
// ./src/app/core/components/partials/learningtile/component.ts